import { Realm } from '../realm/realmSlice'

export interface AdminModeState {
  value: boolean
  favoriteRealm: Realm
}


export const adminModeInitialState: AdminModeState = {
  value: false,
  favoriteRealm: 'fic'
}
